/* eslint-disable no-template-curly-in-string */
/**
 * Authoritative default incoming module per app combination.
 * Ported verbatim from backend incoming-schema.js
 * (UA_APP_INCOMING_DEFAULT_SCHEMA[app].defaultEntityModule).
 *
 * Value semantics:
 *   string  → the app's default module (e.g. Freshdesk → "tickets").
 *             "_only" suffixes are stripped to match the server (person_only → person).
 *   null    → the app has NO fixed default module (server marks its default
 *             entity with entityModuleId: null). This is the case for Monday
 *             boards and Airtable tables — the user must pick a module/board,
 *             so the UI must NOT invent one (e.g. never fall back to "Leads"
 *             or "the first module in the list").
 *   absent  → app not present here; caller decides its own fallback.
 */
export const INCOMING_DEFAULT_ENTITY_MODULE: Record<string, string | null> = {
  "acuityschedulingforairtable": null,
  "acuityschedulingforbitrix24": "lead",
  "acuityschedulingfordynamicscrm": "contact",
  "acuityschedulingforfreshdesk": "tickets",
  "acuityschedulingforfreshworkscrm": "contact",
  "acuityschedulingforhubspotcrm": "Contacts",
  "acuityschedulingformonday": null,
  "acuityschedulingforpipedrive": "person",
  "acuityschedulingforsalesporcecrm": "contact",
  "acuityschedulingforzendesksell": "lead",
  "acuityschedulingforzendesksupport": "tickets",
  "acuityschedulingforzohobigin": "Contacts",
  "acuityschedulingforzohocrm": "Leads",
  "acuityschedulingforzohodesk": "tickets",
  "acuityschedulingforzohorecruit": "Contacts",
  "calendlyforairtable": null,
  "calendlyforbitrix24": "lead",
  "calendlyfordynamicscrm": "contact",
  "calendlyforfreshdesk": "tickets",
  "calendlyforfreshworkscrm": "contact",
  "calendlyforhubspotcrm": "Contacts",
  "calendlyforleadsquared": "Leads",
  "calendlyformonday": null,
  "calendlyforodoocrm": "Leads",
  "calendlyforpipedrive": "person",
  "calendlyforsalesporcecrm": "contact",
  "calendlyforslack": "Channels",
  "calendlyforzendesksell": "lead",
  "calendlyforzendesksupport": "tickets",
  "calendlyforzohobigin": "Contacts",
  "calendlyforzohocrm": "Leads",
  "calendlyforzohodesk": "tickets",
  "calendlyforzohorecruit": "Candidates",
  "clickatellforzohocrm": "Leads",
  "clickatellforzohodesk": "tickets",
  "fast2smsforairtable": null,
  "fast2smsforbitrix24": "lead",
  "fast2smsfordynamicscrm": "contact",
  "fast2smsforfreshdesk": "tickets",
  "fast2smsforfreshworkscrm": "contact",
  "fast2smsforhubspotcrm": "Contacts",
  "fast2smsforleadsquared": "Leads",
  "fast2smsformonday": null,
  "fast2smsforodoocrm": "Leads",
  "fast2smsforpipedrive": "person",
  "fast2smsforsalesporcecrm": "contact",
  "fast2smsforslack": "Channels",
  "fast2smsforzendesksell": "contact",
  "fast2smsforzendesksupport": "tickets",
  "fast2smsforzohobigin": "Contacts",
  "fast2smsforzohocrm": "Leads",
  "fast2smsforzohodesk": "tickets",
  "fast2smsforzohorecruit": "Candidates",
  "intercomformonday": null,
  "intercomforzohocrm": "Leads",
  "karixforhubspotcrm": "Contacts",
  "karixforzohocrm": "Leads",
  "messagebirdforbitrix24": "lead",
  "messagebirdfordynamicscrm": "contact",
  "messagebirdforfreshdesk": "tickets",
  "messagebirdforfreshworkscrm": "contact",
  "messagebirdforhubspotcrm": "Contacts",
  "messagebirdforleadsquared": "Leads",
  "messagebirdformonday": null,
  "messagebirdforpipedrive": "person",
  "messagebirdforsalesporcecrm": "contact",
  "messagebirdforslack": "Channels",
  "messagebirdforzendesksell": "contact",
  "messagebirdforzendesksupport": "tickets",
  "messagebirdforzohobigin": "Contacts",
  "messagebirdforzohocrm": "Leads",
  "messagebirdforzohodesk": "tickets",
  "messagebirdforzohorecruit": "Candidates",
  "pinnacleforbitrix24": "lead",
  "pinnacleforfreshdesk": "tickets",
  "pinnacleforfreshworkscrm": "contact",
  "pinnacleforhubspotcrm": "Contacts",
  "pinnacleforpipedrive": "person",
  "pinnacleforzendesksell": "contact",
  "pinnacleforzendesksupport": "tickets",
  "pinnacleforzohobigin": "Contacts",
  "pinnacleforzohocrm": "Leads",
  "pinnacleforzohodesk": "tickets",
  "ringcentralforbitrix24": "lead",
  "ringcentralfordynamicscrm": "contact",
  "ringcentralforfreshworkscrm": "contact",
  "ringcentralforhubspotcrm": "Contacts",
  "ringcentralforleadsquared": "Leads",
  "ringcentralformonday": null,
  "ringcentralforpipedrive": "person",
  "ringcentralforsalesporcecrm": "contact",
  "ringcentralforzendesksell": "contact",
  "ringcentralforzohobigin": "Contacts",
  "ringcentralforzohocrm": "Leads",
  "ringcentralforzohodesk": "tickets",
  "ringcentralforzohorecruit": "Candidates",
  "routemobileforbitrix24": "lead",
  "routemobilefordynamicscrm": "contact",
  "routemobileforfreshdesk": "tickets",
  "routemobileforfreshworkscrm": "contact",
  "routemobileforhubspotcrm": "Contacts",
  "routemobileforleadsquared": "Leads",
  "routemobileformonday": null,
  "routemobileforpipedrive": "person",
  "routemobileforsalesporcecrm": "contact",
  "routemobileforslack": "Channels",
  "routemobileforzendesksell": "contact",
  "routemobileforzendesksupport": "tickets",
  "routemobileforzohobigin": "Contacts",
  "routemobileforzohocrm": "Leads",
  "routemobileforzohodesk": "tickets",
  "routemobileforzohorecruit": "Candidates",
  "routemobilewaforbitrix24": "lead",
  "routemobilewafordynamicscrm": "contact",
  "routemobilewaforfreshdesk": "tickets",
  "routemobilewaforfreshworkscrm": "contact",
  "routemobilewaforhubspotcrm": "Contacts",
  "routemobilewaforleadsquared": "Leads",
  "routemobilewaformonday": null,
  "routemobilewaforpipedrive": "person",
  "routemobilewaforsalesporcecrm": "contact",
  "routemobilewaforslack": "Channels",
  "routemobilewaforzendesksell": "contact",
  "routemobilewaforzendesksupport": "tickets",
  "routemobilewaforzohobigin": "Contacts",
  "routemobilewaforzohocrm": "Leads",
  "routemobilewaforzohodesk": "tickets",
  "routemobilewaforzohorecruit": "Candidates",
  "stripeforbitrix24": "lead",
  "stripefordynamicscrm": "contact",
  "stripeforhubspotcrm": "Contacts",
  "stripeforleadsquared": "Leads",
  "stripeforpipedrive": "person",
  "stripeforsalesporcecrm": "contact",
  "stripeforzendesksell": "lead",
  "stripeforzohocrm": "Contacts",
  "telnyxforzohocrm": "Leads",
  "telnyxforzohodesk": "tickets",
  "textmagicforfreshdesk": "tickets",
  "twilioforactivecampaign": "Contacts",
  "twilioforairtable": null,
  "twilioforbitrix24": "lead",
  "twiliofordynamicscrm": "contact",
  "twilioforfreshdesk": "tickets",
  "twilioforfreshworkscrm": "contact",
  "twilioforhigh": "contact",
  "twilioforhubspotcrm": "Contacts",
  "twilioforleadsquared": "Leads",
  "twilioformonday": null,
  "twilioforodoocrm": "Leads",
  "twilioforpipedrive": "person",
  "twilioforsalesporcecrm": "contact",
  "twilioforslack": "Channels",
  "twilioforzendesksell": "contact",
  "twilioforzendesksupport": "tickets",
  "twilioforzohobigin": "Contacts",
  "twilioforzohocrm": "Leads",
  "twilioforzohodesk": "tickets",
  "twilioforzohorecruit": "Candidates",
  "whatcetraforbitrix24": "lead",
  "whatcetrafordynamicscrm": "contact",
  "whatcetraforfreshdesk": "tickets",
  "whatcetraforfreshworkscrm": "contact",
  "whatcetraforhubspotcrm": "Contacts",
  "whatcetraforleadsquared": "Leads",
  "whatcetraforpipedrive": "person",
  "whatcetraforsalesporcecrm": "contact",
  "whatcetraforzendesksell": "contact",
  "whatcetraforzendesksupport": "tickets",
  "whatcetraforzohobigin": "Contacts",
  "whatcetraforzohocrm": "Leads",
  "whatcetraforzohodesk": "tickets",
  "whatcetraforzohorecruit": "Candidates",
  "whatsappforfreshdesk": "tickets",
  "whatsappforhubspotcrm": "Contacts",
  "whatsappforpipedrive": "person",
  "whatsappforzendesksupport": "tickets",
  "whatsappforzohobigin": "Contacts",
  "whatsappforzohocrm": "Leads",
  "whatsappforzohodesk": "tickets",
};

/**
 * Resolve the authoritative default incoming module for an app.
 * Returns:
 *   - the module name (string) when the app has a fixed default,
 *   - null when the app explicitly has NO default (Monday/Airtable),
 *   - undefined when the app is unknown to this map (caller picks a fallback).
 * Mirrors the server: the default comes from defaultEntityModule, never from
 * "the first supported module".
 */
export function getIncomingDefaultModule(
  extensionName?: string
): string | null | undefined {
  if (!extensionName) return undefined;
  if (!(extensionName in INCOMING_DEFAULT_ENTITY_MODULE)) return undefined;
  return INCOMING_DEFAULT_ENTITY_MODULE[extensionName];
}

/**
 * Default incoming FIELD MAPPINGS per app combination (used to pre-populate
 * a new card's fields). Key: extensionName. Value: { moduleName: { crmField: expr } }.
 */
export const INCOMING_DEFAULT_SCHEMA: Record<string, Record<string, Record<string, string>>> = {
  "twilioforzohocrm": {
    "Leads": {
      "Last_Name": "Twilio - ${{{$.from}}}",
      "Mobile": "${{{$.from}}}",
      "Phone": "${{{$.from}}}",
      "Lead_Source": "Twilio"
    },
    "Contacts": {
      "Last_Name": "Twilio - ${{{$.from}}}",
      "Mobile": "${{{$.from}}}",
      "Phone": "${{{$.from}}}"
    },
    "Accounts": {
      "Account_Name": "Twilio - ${{{$.from}}}",
      "Mobile": "${{{$.from}}}",
      "Phone": "${{{$.from}}}"
    }
  },
  "twilioforodoocrm": {
    "Leads": {
      "name": "Twilio - ${{{$.from}}}",
      "mobile": "${{{$.from}}}",
      "phone": "${{{$.from}}}",
      "Lead_Source": "Twilio"
    },
    "Contacts": {
      "name": "Twilio - ${{{$.from}}}",
      "mobile": "${{{$.from}}}",
      "phone": "${{{$.from}}}"
    }
  },
  "clickatellforzohocrm": {
    "Leads": {
      "Last_Name": "Clickatell - ${{{$.from}}}",
      "Mobile": "${{{$.from}}}",
      "Phone": "${{{$.from}}}",
      "Lead_Source": "Clickatell"
    },
    "Contacts": {
      "Last_Name": "Twilio - ${{{$.from}}}",
      "Mobile": "${{{$.from}}}",
      "Phone": "${{{$.from}}}"
    },
    "Accounts": {
      "Account_Name": "Twilio - ${{{$.from}}}",
      "Mobile": "${{{$.from}}}",
      "Phone": "${{{$.from}}}"
    }
  },
  "karixforzohocrm": {
    "Leads": {
      "Last_Name": "Karix - ${{{$.from}}}",
      "Mobile": "${{{$.from}}}",
      "Phone": "${{{$.from}}}",
      "Lead_Source": "Karix"
    },
    "Contacts": {
      "Last_Name": "Karix - ${{{$.from}}}",
      "Mobile": "${{{$.from}}}",
      "Phone": "${{{$.from}}}"
    },
    "Accounts": {
      "Account_Name": "Karix - ${{{$.from}}}",
      "Mobile": "${{{$.from}}}",
      "Phone": "${{{$.from}}}"
    }
  },
  "pinnacleforzohocrm": {
    "Leads": {
      "Last_Name": "Pinnacle - ${{{$.contact.name}}}",
      "Mobile": "${{{$.from}}}",
      "Phone": "${{{$.from}}}",
      "Lead_Source": "Pinnacle"
    },
    "Contacts": {
      "Last_Name": "Pinnacle - ${{{$.contact.name}}}",
      "Mobile": "${{{$.from}}}",
      "Phone": "${{{$.from}}}"
    },
    "Accounts": {
      "Account_Name": "Pinnacle - ${{{$.contact.name}}}",
      "Mobile": "${{{$.from}}}",
      "Phone": "${{{$.from}}}"
    }
  },
  "twilioforhigh": {
    "contact": {
      "firstName": "Twilio",
      "lastName": "${{{$.from}}}",
      "phone": "${{{$.from}}}",
      "source": "Twilio"
    }
  },
  "twilioforhubspotcrm": {
    "Contacts": {
      "lastname": "Twilio - ${{{$.from}}}",
      "phone": "${{{$.from}}}"
    },
    "Tickets": {
      "subject": "Twilio - ${{{$.from}}} - ${{{$.body}}}"
    }
  },
  "karixforhubspotcrm": {
    "Contacts": {
      "lastname": "Karix - ${{{$.from}}}",
      "phone": "${{{$.from}}}"
    }
  },
  "ringcentralforzohocrm": {
    "Leads": {
      "Last_Name": "RingCentral - ${{{$.from}}}",
      "Mobile": "${{{$.from}}}",
      "Phone": "${{{$.from}}}",
      "Lead_Source": "RingCentral"
    },
    "Contacts": {
      "Last_Name": "RingCentral - ${{{$.from}}}",
      "Mobile": "${{{$.from}}}",
      "Phone": "${{{$.from}}}"
    },
    "Accounts": {
      "Account_Name": "RingCentral - ${{{$.from}}}",
      "Mobile": "${{{$.from}}}",
      "Phone": "${{{$.from}}}"
    }
  },
  "messagebirdforzohocrm": {
    "Leads": {
      "Last_Name": "${{{$.contact.displayName}}} ${{{$.message.platform}}} - MessageBird",
      "Mobile": "${{{$.contact.msisdn}}}",
      "Phone": "${{{$.contact.msisdn}}}",
      "Lead_Source": "MessageBird",
      "Email": "${{{$.contact.email}}}"
    },
    "Contacts": {
      "Last_Name": "${{{$.contact.displayName}}} ${{{$.message.platform}}} - MessageBird",
      "Mobile": "${{{$.contact.msisdn}}}",
      "Phone": "${{{$.contact.msisdn}}}",
      "Email": "${{{$.contact.email}}}"
    },
    "Accounts": {
      "Account_Name": "${{{$.contact.displayName}}} - MessageBird",
      "Mobile": "${{{$.contact.msisdn}}}",
      "Phone": "${{{$.contact.msisdn}}}"
    }
  },
  "routemobileforzohocrm": {
    "Leads": {
      "Last_Name": "${{{$.contacts[0].profile.name}}}  - Route Mobile",
      "Mobile": "${{{$.contacts[0].wa_id}}}",
      "Phone": "${{{$.contacts[0].wa_id}}}",
      "Lead_Source": "Route Mobile"
    },
    "Contacts": {
      "Last_Name": "${{{$.contacts[0].profile.name}}} - Route Mobile",
      "Mobile": "${{{$.contacts[0].wa_id}}}",
      "Phone": "${{{$.contacts[0].wa_id}}}"
    },
    "Accounts": {
      "Account_Name": "${{{$.contacts[0].profile.name}}} - Route Mobile",
      "Mobile": "${{{$.contacts[0].wa_id}}}",
      "Phone": "${{{$.contacts[0].wa_id}}}"
    }
  },
  "routemobilewaforzohocrm": {
    "Leads": {
      "Last_Name": "${{{$.contacts[0].profile.name}}}  - Route Mobile",
      "Mobile": "${{{$.contacts[0].wa_id}}}",
      "Phone": "${{{$.contacts[0].wa_id}}}",
      "Lead_Source": "Route Mobile"
    },
    "Contacts": {
      "Last_Name": "${{{$.contacts[0].profile.name}}} - Route Mobile",
      "Mobile": "${{{$.contacts[0].wa_id}}}",
      "Phone": "${{{$.contacts[0].wa_id}}}"
    },
    "Accounts": {
      "Account_Name": "${{{$.contacts[0].profile.name}}} - Route Mobile",
      "Mobile": "${{{$.contacts[0].wa_id}}}",
      "Phone": "${{{$.contacts[0].wa_id}}}"
    }
  },
  "whatsappforzohocrm": {
    "Leads": {
      "Last_Name": "${{{$.contact.name}}}",
      "Mobile": "${{{$.from}}}",
      "Phone": "${{{$.from}}}",
      "Lead_Source": "WhatsApp"
    },
    "Contacts": {
      "Last_Name": "${{{$.contact.name}}}",
      "Mobile": "${{{$.from}}}",
      "Phone": "${{{$.from}}}"
    },
    "Accounts": {
      "Account_Name": "${{{$.contact.name}}}",
      "Mobile": "${{{$.from}}}",
      "Phone": "${{{$.from}}}"
    }
  },
  "whatsappforhubspotcrm": {
    "Contacts": {
      "lastname": "WhatsApp - ${{{$.from}}} - ${{{$.contact.name}}}",
      "phone": "${{{$.from}}}"
    },
    "Tickets": {
      "subject": "WhatsApp - ${{{$.from}}} - ${{{$.contact.name}}}"
    }
  },
  "pinnacleforhubspotcrm": {
    "Contacts": {
      "lastname": "Pinnacle - ${{{$.from}}} - ${{{$.contact.name}}}",
      "phone": "${{{$.from}}}"
    },
    "Tickets": {
      "subject": "Pinnacle - ${{{$.from}}} - ${{{$.contact.name}}}"
    }
  },
  "ringcentralforhubspotcrm": {
    "Contacts": {
      "lastname": "Ringcentral - ${{{$.from}}}",
      "phone": "${{{$.from}}}"
    }
  },
  "stripeforzohocrm": {
    "Leads": {
      "Last_Name": "${{{$.data.object.customer_name}}} - Stripe",
      "Mobile": "${{{$.data.object.customer_phone}}}",
      "Phone": "${{{$.data.object.customer_phone}}}",
      "Lead_Source": "Stripe",
      "Email": "${{{$.data.object.customer_email}}}"
    },
    "Contacts": {
      "Last_Name": "${{{$.data.object.customer_name}}} - Stripe",
      "Mobile": "${{{$.data.object.customer_phone}}}",
      "Phone": "${{{$.data.object.customer_phone}}}",
      "Email": "${{{$.data.object.customer_email}}}"
    },
    "Accounts": {
      "Last_Name": "${{{$.data.object.customer_name}}} - Stripe",
      "Mobile": "${{{$.data.object.customer_phone}}}",
      "Phone": "${{{$.data.object.customer_phone}}}",
      "Email": "${{{$.data.object.customer_email}}}"
    }
  },
  "stripeforhubspotcrm": {
    "Contacts": {
      "lastname": "${{{$.data.object.customer_name}}}",
      "phone": "${{{$.data.object.customer_phone}}}",
      "email": "${{{$.data.object.customer_email}}}"
    }
  },
  "stripeforbitrix24": {
    "lead": {
      "NAME": "${{{$.data.object.customer_name}}}",
      "EMAIL": "${{{$.data.object.customer_email}}}",
      "PHONE": "${{{$.data.object.customer_phone}}}"
    },
    "contact": {
      "NAME": "${{{$.data.object.customer_name}}}",
      "EMAIL": "${{{$.data.object.customer_email}}}",
      "PHONE": "${{{$.data.object.customer_phone}}}"
    },
    "deal": {
      "NAME": "${{{$.data.object.customer_name}}}",
      "EMAIL": "${{{$.data.object.customer_email}}}",
      "PHONE": "${{{$.data.object.customer_phone}}}"
    }
  },
  "stripeforsalesporcecrm": {
    "lead": {
      "LastName": "${{{$.data.object.customer_name}}}",
      "Company": "${{{$.data.object.customer_name}}}",
      "Email": "${{{$.data.object.customer_email}}}",
      "Phone": "${{{$.data.object.customer_phone}}}"
    },
    "contact": {
      "LastName": "${{{$.data.object.customer_name}}}",
      "Email": "${{{$.data.object.customer_email}}}",
      "Phone": "${{{$.data.object.customer_phone}}}"
    },
    "account": {
      "Name": "${{{$.data.object.customer_name}}}",
      "Phone": "${{{$.data.object.customer_phone}}}"
    }
  },
  "stripefordynamicscrm": {
    "lead": {
      "firstname": "Stripe - ",
      "lastname": "${{{$.data.object.customer_name}}}",
      "emailaddress1": "${{{$.data.object.customer_email}}}",
      "telephone1": "${{{$.data.object.customer_phone}}}"
    },
    "account": {
      "name": "Stripe - ${{{$.data.object.customer_name}}}",
      "telephone1": "${{{$.data.object.customer_phone}}}"
    },
    "contact": {
      "firstname": "Stripe - ",
      "lastname": "${{{$.data.object.customer_name}}}",
      "emailaddress1": "${{{$.data.object.customer_email}}}",
      "telephone1": "${{{$.data.object.customer_phone}}}"
    }
  },
  "stripeforleadsquared": {
    "Leads": {
      "LastName": "${{{$.data.object.customer_name}}} (Stripe)",
      "phone": "${{{$.data.object.customer_phone}}}",
      "EmailAddress": "${{{$.data.object.customer_email}}}"
    }
  },
  "messagebirdforhubspotcrm": {
    "Contacts": {
      "lastname": "${{{$.contact.displayName}}} ${{{$.message.platform}}} - MessageBird",
      "phone": "${{{$.contact.msisdn}}}",
      "email": "${{{$.contact.email}}}"
    },
    "Tickets": {
      "subject": "Messagebird - ${{{$.contact.msisdn}}}"
    }
  },
  "routemobileforhubspotcrm": {
    "Contacts": {
      "lastname": "${{{$.contacts[0].profile.name}}} - Route Mobile",
      "phone": "${{{$.contacts[0].wa_id}}}"
    }
  },
  "routemobilewaforhubspotcrm": {
    "Contacts": {
      "lastname": "${{{$.contacts[0].profile.name}}} - Route Mobile",
      "phone": "${{{$.contacts[0].wa_id}}}"
    }
  },
  "acuityschedulingforhubspotcrm": {
    "Contacts": {
      "lastname": "${{{$.contact.name}}}",
      "phone": "${{{$.contact.phone}}}",
      "email": "${{{$.contact.email}}}"
    },
    "Tickets": {
      "subject": "Acuity - ${{{$.contact.name}}}"
    }
  },
  "calendlyforhubspotcrm": {
    "Contacts": {
      "lastname": "${{{$.contact.name}}}",
      "phone": "${{{$.contact.phone}}}",
      "email": "${{{$.contact.email}}}"
    },
    "Tickets": {
      "subject": "Calendly - ${{{$.contact.name}}}"
    }
  },
  "calendlyforzohocrm": {
    "Leads": {
      "Last_Name": "${{{$.contact.name}}}",
      "Email": "${{{$.contact.email}}}",
      "Mobile": "${{{$.contact.phone}}}",
      "Phone": "${{{$.contact.phone}}}",
      "Lead_Source": "Calendly"
    },
    "Contacts": {
      "Last_Name": "${{{$.contact.name}}}",
      "Mobile": "${{{$.contact.phone}}}",
      "Phone": "${{{$.contact.phone}}}",
      "Email": "${{{$.contact.email}}}"
    },
    "Accounts": {
      "Account_Name": "${{{$.contact.name}}}",
      "Mobile": "${{{$.contact.phone}}}",
      "Phone": "${{{$.contact.phone}}}",
      "Email": "${{{$.contact.email}}}"
    }
  },
  "calendlyforodoocrm": {
    "Leads": {
      "name": "${{{$.contact.name}}}",
      "email_from": "${{{$.contact.email}}}",
      "mobile": "${{{$.contact.phone}}}",
      "phone": "${{{$.contact.phone}}}",
      "Lead_Source": "Calendly"
    },
    "Contacts": {
      "name": "${{{$.contact.name}}}",
      "mobile": "${{{$.contact.phone}}}",
      "phone": "${{{$.contact.phone}}}",
      "email": "${{{$.contact.email}}}"
    }
  },
  "calendlyforslack": {
    "Channels": {
      "name": "Calendly - ${{{$.contact.name}}} ${{{$.contact.email}}}"
    }
  },
  "acuityschedulingforzohocrm": {
    "Leads": {
      "Last_Name": "${{{$.contact.name}}}",
      "Email": "${{{$.contact.email}}}",
      "Mobile": "${{{$.contact.phone}}}",
      "Phone": "${{{$.contact.phone}}}",
      "Lead_Source": "AcuityScheduling"
    },
    "Contacts": {
      "Last_Name": "${{{$.contact.name}}}",
      "Mobile": "${{{$.contact.phone}}}",
      "Phone": "${{{$.contact.phone}}}",
      "Email": "${{{$.contact.email}}}"
    },
    "Accounts": {
      "Account_Name": "${{{$.contact.name}}}",
      "Mobile": "${{{$.contact.phone}}}",
      "Phone": "${{{$.contact.phone}}}",
      "Email": "${{{$.contact.email}}}"
    }
  },
  "whatcetraforzohocrm": {
    "Leads": {
      "Last_Name": "${{{$.customerNumber}}}",
      "Mobile": "${{{$.customerNumber}}}",
      "Phone": "${{{$.customerNumber}}}",
      "Lead_Source": "Whatcetra"
    },
    "Contacts": {
      "Last_Name": "${{{$.customerNumber}}}",
      "Mobile": "${{{$.customerNumber}}}",
      "Phone": "${{{$.customerNumber}}}"
    },
    "Accounts": {
      "Account_Name": "${{{$.customerNumber}}}",
      "Phone": "${{{$.customerNumber}}}",
      "Mobile": "${{{$.customerNumber}}}"
    }
  },
  "whatcetraforhubspotcrm": {
    "Contacts": {
      "lastname": "${{{$.customerNumber}}}",
      "phone": "${{{$.customerNumber}}}"
    }
  },
  "whatcetraforbitrix24": {
    "lead": {
      "NAME": "${{{$.customerNumber}}}",
      "PHONE": "${{{$.customerNumber}}}"
    },
    "contact": {
      "NAME": "${{{$.customerNumber}}}",
      "PHONE": "${{{$.customerNumber}}}"
    },
    "deal": {
      "NAME": "${{{$.customerNumber}}}",
      "PHONE": "${{{$.customerNumber}}}"
    }
  },
  "pinnacleforbitrix24": {
    "lead": {
      "NAME": "Pinnacle - ${{{$.contact.name}}}",
      "PHONE": "${{{$.from}}}"
    },
    "contact": {
      "NAME": "Pinnacle - ${{{$.contact.name}}}",
      "PHONE": "${{{$.from}}}"
    },
    "deal": {
      "NAME": "Pinnacle - ${{{$.contact.name}}}",
      "PHONE": "${{{$.from}}}"
    }
  },
  "twilioforbitrix24": {
    "lead": {
      "NAME": "Twilio - ${{{$.from}}}",
      "PHONE": "${{{$.from}}}"
    },
    "contact": {
      "NAME": "Twilio - ${{{$.from}}}",
      "PHONE": "${{{$.from}}}"
    },
    "deal": {
      "NAME": "Twilio - ${{{$.from}}}",
      "PHONE": "${{{$.from}}}"
    }
  },
  "messagebirdforbitrix24": {
    "lead": {
      "NAME": "${{{$.contact.displayName}}} - ${{{$.message.platform}}}",
      "PHONE": "${{{$.contact.msisdn}}}"
    },
    "contact": {
      "NAME": "${{{$.contact.displayName}}} - ${{{$.message.platform}}}",
      "PHONE": "${{{$.contact.msisdn}}}"
    },
    "deal": {
      "NAME": "${{{$.contact.displayName}}} - ${{{$.message.platform}}}",
      "PHONE": "${{{$.contact.msisdn}}}"
    }
  },
  "routemobileforbitrix24": {
    "lead": {
      "NAME": "${{{$.contacts[0].profile.name}}} - Route Mobile",
      "PHONE": "${{{$.contacts[0].wa_id}}}"
    },
    "contact": {
      "NAME": "${{{$.contacts[0].profile.name}}} - Route Mobile",
      "PHONE": "${{{$.contacts[0].wa_id}}}"
    },
    "deal": {
      "NAME": "${{{$.contacts[0].profile.name}}} - Route Mobile",
      "PHONE": "${{{$.contacts[0].wa_id}}}"
    }
  },
  "routemobilewaforbitrix24": {
    "lead": {
      "NAME": "${{{$.contacts[0].profile.name}}} - Route Mobile",
      "PHONE": "${{{$.contacts[0].wa_id}}}"
    },
    "contact": {
      "NAME": "${{{$.contacts[0].profile.name}}} - Route Mobile",
      "PHONE": "${{{$.contacts[0].wa_id}}}"
    },
    "deal": {
      "NAME": "${{{$.contacts[0].profile.name}}} - Route Mobile",
      "PHONE": "${{{$.contacts[0].wa_id}}}"
    }
  },
  "ringcentralforbitrix24": {
    "lead": {
      "NAME": "RingCentral - ${{{$.from}}}",
      "PHONE": "${{{$.from}}}"
    },
    "contact": {
      "NAME": "RingCentral - ${{{$.from}}}",
      "PHONE": "${{{$.from}}}"
    },
    "deal": {
      "NAME": "RingCentral - ${{{$.from}}}",
      "PHONE": "${{{$.from}}}"
    }
  },
  "calendlyforbitrix24": {
    "lead": {
      "NAME": "${{{$.contact.name}}}",
      "EMAIL": "${{{$.contact.email}}}",
      "PHONE": "${{{$.contact.phone}}}"
    },
    "contact": {
      "NAME": "${{{$.contact.name}}}",
      "EMAIL": "${{{$.contact.email}}}",
      "PHONE": "${{{$.contact.phone}}}"
    },
    "deal": {
      "NAME": "${{{$.contact.name}}}",
      "EMAIL": "${{{$.contact.email}}}",
      "PHONE": "${{{$.contact.phone}}}"
    }
  },
  "acuityschedulingforbitrix24": {
    "lead": {
      "NAME": "${{{$.contact.name}}}",
      "EMAIL": "${{{$.contact.email}}}",
      "PHONE": "${{{$.contact.phone}}}"
    },
    "contact": {
      "NAME": "${{{$.contact.name}}}",
      "EMAIL": "${{{$.contact.email}}}",
      "PHONE": "${{{$.contact.phone}}}"
    },
    "deal": {
      "NAME": "${{{$.contact.name}}}",
      "EMAIL": "${{{$.contact.email}}}",
      "PHONE": "${{{$.contact.phone}}}"
    }
  },
  "calendlyforsalesporcecrm": {
    "lead": {
      "LastName": "${{{$.contact.name}}}",
      "Company": "${{{$.contact.name}}}",
      "Email": "${{{$.contact.email}}}",
      "Phone": "${{{$.contact.phone}}}"
    },
    "contact": {
      "LastName": "${{{$.contact.name}}}",
      "Email": "${{{$.contact.email}}}",
      "Phone": "${{{$.contact.phone}}}"
    },
    "account": {
      "Name": "${{{$.contact.name}}}",
      "Phone": "${{{$.contact.phone}}}"
    }
  },
  "acuityschedulingforsalesporcecrm": {
    "lead": {
      "LastName": "${{{$.contact.name}}}",
      "Company": "${{{$.contact.name}}}",
      "Email": "${{{$.contact.email}}}",
      "Phone": "${{{$.contact.phone}}}"
    },
    "contact": {
      "LastName": "${{{$.contact.name}}}",
      "Email": "${{{$.contact.email}}}",
      "Phone": "${{{$.contact.phone}}}"
    },
    "account": {
      "Name": "${{{$.contact.name}}}",
      "Phone": "${{{$.contact.phone}}}"
    }
  },
  "twilioforsalesporcecrm": {
    "lead": {
      "LastName": "Twilio - ${{{$.from}}}",
      "Company": "Twilio - ${{{$.from}}}",
      "Phone": "${{{$.from}}}"
    },
    "contact": {
      "LastName": "Twilio - ${{{$.from}}}",
      "Phone": "${{{$.from}}}"
    },
    "account": {
      "Name": "Twilio - ${{{$.from}}}",
      "Phone": "${{{$.from}}}"
    }
  },
  "messagebirdforsalesporcecrm": {
    "lead": {
      "LastName": "${{{$.contact.displayName}}} ${{{$.message.platform}}} - MessageBird",
      "Company": "${{{$.contact.displayName}}} ${{{$.message.platform}}} - MessageBird",
      "Email": "${{{$.contact.email}}}",
      "Phone": "${{{$.contact.msisdn}}}"
    },
    "contact": {
      "LastName": "${{{$.contact.displayName}}} ${{{$.message.platform}}} - MessageBird",
      "Email": "${{{$.contact.email}}}",
      "Phone": "${{{$.contact.msisdn}}}"
    },
    "account": {
      "Name": "${{{$.contact.displayName}}} ${{{$.message.platform}}} - MessageBird",
      "Phone": "${{{$.contact.msisdn}}}"
    }
  },
  "routemobileforsalesporcecrm": {
    "lead": {
      "LastName": "${{{$.contacts[0].profile.name}}} - Route Mobile",
      "Company": "${{{$.contacts[0].profile.name}}} - Route Mobile",
      "Phone": "${{{$.contacts[0].wa_id}}}"
    },
    "contact": {
      "LastName": "${{{$.contacts[0].profile.name}}} - Route Mobile",
      "Phone": "${{{$.contacts[0].wa_id}}}"
    },
    "account": {
      "Name": "${{{$.contacts[0].profile.name}}} - Route Mobile",
      "Phone": "${{{$.contacts[0].wa_id}}}"
    }
  },
  "routemobilewaforsalesporcecrm": {
    "lead": {
      "LastName": "${{{$.contacts[0].profile.name}}} - Route Mobile",
      "Company": "${{{$.contacts[0].profile.name}}} - Route Mobile",
      "Phone": "${{{$.contacts[0].wa_id}}}"
    },
    "contact": {
      "LastName": "${{{$.contacts[0].profile.name}}} - Route Mobile",
      "Phone": "${{{$.contacts[0].wa_id}}}"
    },
    "account": {
      "Name": "${{{$.contacts[0].profile.name}}} - Route Mobile",
      "Phone": "${{{$.contacts[0].wa_id}}}"
    }
  },
  "ringcentralforsalesporcecrm": {
    "lead": {
      "LastName": "RingCentral - ${{{$.from}}}",
      "Company": "RingCentral - ${{{$.from}}}",
      "Phone": "${{{$.from}}}"
    },
    "contact": {
      "LastName": "RingCentral - ${{{$.from}}}",
      "Phone": "${{{$.from}}}"
    },
    "account": {
      "Name": "RingCentral - ${{{$.from}}}",
      "Phone": "${{{$.from}}}"
    }
  },
  "whatcetraforsalesporcecrm": {
    "lead": {
      "LastName": "Whatcetra - ${{{$.customerNumber}}}",
      "Company": "Whatcetra - ${{{$.customerNumber}}}",
      "Phone": "${{{$.customerNumber}}}"
    },
    "contact": {
      "LastName": "Whatcetra - ${{{$.customerNumber}}}",
      "Phone": "${{{$.customerNumber}}}"
    },
    "account": {
      "Name": "Whatcetra - ${{{$.customerNumber}}}",
      "Phone": "${{{$.customerNumber}}}"
    }
  },
  "telnyxforzohocrm": {
    "Leads": {
      "Last_Name": "${{{$.customerNumber}}}",
      "Mobile": "${{{$.customerNumber}}}",
      "Phone": "${{{$.customerNumber}}}",
      "Lead_Source": "Telnyx"
    },
    "Contacts": {
      "Last_Name": "${{{$.customerNumber}}}",
      "Mobile": "${{{$.customerNumber}}}",
      "Phone": "${{{$.customerNumber}}}"
    },
    "Accounts": {
      "Account_Name": "${{{$.customerNumber}}}",
      "Phone": "${{{$.customerNumber}}}",
      "Mobile": "${{{$.customerNumber}}}"
    }
  },
  "twilioforzohodesk": {
    "tickets": {
      "subject": "${{{$.body}}}",
      "phone": "${{{$.from}}}",
      "channel": "Twilio"
    },
    "contacts": {
      "lastName": "${{{$.from}}}",
      "phone": "${{{$.from}}}",
      "email": "${{{$.from}}}@twilioforzohodesk.apps.ulgebra.com"
    }
  },
  "clickatellforzohodesk": {
    "tickets": {
      "subject": "Clickatell - ${{{$.from}}}",
      "phone": "${{{$.from}}}",
      "channel": "Clickatell"
    },
    "contacts": {
      "lastName": "${{{$.from}}}",
      "phone": "${{{$.from}}}",
      "email": "${{{$.from}}}@clickatellforzohodesk.apps.ulgebra.com"
    }
  },
  "messagebirdforzohodesk": {
    "tickets": {
      "subject": "${{{$.message.type}}} - ${{{$.message.content.text}}}",
      "phone": "${{{$.contact.msisdn}}}",
      "channel": "MessageBird"
    },
    "contacts": {
      "lastName": "${{{$.contact.displayName}}} via ${{{$.message.platform}}}",
      "phone": "${{{$.contact.msisdn}}}",
      "email": "${{{$.contact.email}}}"
    }
  },
  "routemobileforzohodesk": {
    "tickets": {
      "subject": "${{{$.messages[0].type}}} - ${{{$.messages[0].text.body}}}",
      "phone": "${{{$.contacts[0].wa_id}}}",
      "channel": "RouteMobile"
    },
    "contacts": {
      "lastName": "${{{$.contacts[0].profile.name}}} - Route Mobile",
      "phone": "${{{$.contacts[0].wa_id}}}"
    }
  },
  "routemobilewaforzohodesk": {
    "tickets": {
      "subject": "${{{$.messages[0].type}}} - ${{{$.messages[0].text.body}}}",
      "phone": "${{{$.contacts[0].wa_id}}}",
      "channel": "RouteMobile"
    },
    "contacts": {
      "lastName": "${{{$.contacts[0].profile.name}}} - Route Mobile",
      "phone": "${{{$.contacts[0].wa_id}}}"
    }
  },
  "acuityschedulingforzohodesk": {
    "tickets": {
      "subject": "Acuity Event - ${{{$.contact.name}}}",
      "phone": "${{{$.contact.phone}}}",
      "channel": "Acuity"
    },
    "contacts": {
      "lastName": "${{{$.contact.name}}}",
      "phone": "${{{$.contact.phone}}}",
      "email": "${{{$.contact.email}}}"
    }
  },
  "calendlyforzohodesk": {
    "tickets": {
      "subject": "Calendly Event - ${{{$.contact.name}}}",
      "phone": "${{{$.contact.phone}}}",
      "channel": "Calendly"
    },
    "contacts": {
      "lastName": "${{{$.contact.name}}}",
      "phone": "${{{$.contact.phone}}}",
      "email": "${{{$.contact.email}}}"
    }
  },
  "messagebirdforfreshdesk": {
    "tickets": {
      "name": "${{{$.contact.displayName}}} ${{{$.message.from}}} via ${{{$.message.platform}}}",
      "phone": "${{{$.contact.msisdn}}}",
      "email": "${{{$.contact.email}}}"
    },
    "contacts": {
      "name": "${{{$.contact.displayName}}} ${{{$.message.from}}} via ${{{$.message.platform}}}",
      "phone": "${{{$.contact.msisdn}}}",
      "email": "${{{$.contact.email}}}"
    }
  },
  "routemobileforfreshdesk": {
    "tickets": {
      "name": "${{{$.contacts[0].profile.name}}}",
      "phone": "${{{$.contacts[0].wa_id}}}"
    },
    "contacts": {
      "name": "${{{$.contacts[0].profile.name}}}",
      "phone": "${{{$.contacts[0].wa_id}}}"
    }
  },
  "routemobilewaforfreshdesk": {
    "tickets": {
      "name": "${{{$.contacts[0].profile.name}}}",
      "phone": "${{{$.contacts[0].wa_id}}}"
    },
    "contacts": {
      "name": "${{{$.contacts[0].profile.name}}}",
      "phone": "${{{$.contacts[0].wa_id}}}"
    }
  },
  "twilioforfreshdesk": {
    "tickets": {
      "name": "Twilio - ${{{$.from}}}",
      "phone": "${{{$.from}}}"
    },
    "contacts": {
      "name": "Twilio - ${{{$.from}}}",
      "phone": "${{{$.from}}}"
    }
  },
  "textmagicforfreshdesk": {
    "tickets": {
      "name": "TextMagic - ${{{$.from}}}",
      "phone": "${{{$.from}}}"
    },
    "contacts": {
      "name": "TextMagic - ${{{$.from}}}",
      "phone": "${{{$.from}}}"
    }
  },
  "calendlyforfreshdesk": {
    "tickets": {
      "name": "${{{$.contact.name}}}",
      "phone": "${{{$.contact.phone}}}",
      "email": "${{{$.contact.email}}}"
    },
    "contacts": {
      "name": "${{{$.contact.name}}}",
      "phone": "${{{$.contact.phone}}}",
      "email": "${{{$.contact.email}}}"
    }
  },
  "acuityschedulingforfreshdesk": {
    "tickets": {
      "name": "${{{$.contact.name}}}",
      "phone": "${{{$.contact.phone}}}",
      "email": "${{{$.contact.email}}}"
    },
    "contacts": {
      "name": "${{{$.contact.name}}}",
      "phone": "${{{$.contact.phone}}}",
      "email": "${{{$.contact.email}}}"
    }
  },
  "whatsappforfreshdesk": {
    "tickets": {
      "name": "WhatsApp - ${{{$.contact.name}}}",
      "phone": "${{{$.from}}}"
    },
    "contacts": {
      "name": "WhatsApp - ${{{$.contact.name}}}",
      "phone": "${{{$.from}}}"
    }
  },
  "pinnacleforfreshdesk": {
    "tickets": {
      "name": "Pinnacle - ${{{$.contact.name}}}",
      "phone": "${{{$.from}}}"
    },
    "contacts": {
      "name": "Pinnacle - ${{{$.contact.name}}}",
      "phone": "${{{$.from}}}"
    }
  },
  "acuityschedulingforzendesksupport": {
    "tickets": {
      "name": "${{{$.contact.name}}}",
      "phone": "${{{$.contact.phone}}}",
      "email": "${{{$.contact.email}}}"
    }
  },
  "calendlyforzendesksupport": {
    "tickets": {
      "name": "${{{$.contact.name}}}",
      "phone": "${{{$.contact.phone}}}",
      "email": "${{{$.contact.email}}}"
    }
  },
  "twilioforzohobigin": {
    "Contacts": {
      "Last_Name": "Twilio - ${{{$.from}}}",
      "Mobile": "${{{$.from}}}",
      "Phone": "${{{$.from}}}"
    }
  },
  "acuityschedulingforzohobigin": {
    "Contacts": {
      "Last_Name": "${{{$.contact.name}}}",
      "Phone": "${{{$.contact.phone}}}",
      "Email": "${{{$.contact.email}}}"
    }
  },
  "acuityschedulingforzohorecruit": {
    "Contacts": {
      "Last_Name": "${{{$.contact.name}}}",
      "Mobile": "${{{$.contact.phone}}}",
      "Phone": "${{{$.contact.phone}}}",
      "Email": "${{{$.contact.email}}}"
    },
    "Candidates": {
      "Last_Name": "${{{$.contact.name}}}",
      "First_Name": "Acuity Scheduling",
      "Mobile": "${{{$.contact.phone}}}",
      "Phone": "${{{$.contact.phone}}}",
      "Email": "${{{$.contact.email}}}"
    }
  },
  "messagebirdforzohobigin": {
    "Contacts": {
      "Last_Name": "${{{$.contact.displayName}}} ${{{$.message.platform}}} - MessageBird",
      "Mobile": "${{{$.contact.msisdn}}}",
      "Phone": "${{{$.contact.msisdn}}}",
      "Email": "${{{$.contact.email}}}"
    }
  },
  "routemobileforzohobigin": {
    "Contacts": {
      "Last_Name": "${{{$.contacts[0].profile.name}}} - Route Mobile",
      "Mobile": "${{{$.contacts[0].wa_id}}}",
      "Phone": "${{{$.contacts[0].wa_id}}}"
    }
  },
  "routemobilewaforzohobigin": {
    "Contacts": {
      "Last_Name": "${{{$.contacts[0].profile.name}}} - Route Mobile",
      "Mobile": "${{{$.contacts[0].wa_id}}}",
      "Phone": "${{{$.contacts[0].wa_id}}}"
    }
  },
  "ringcentralforzohobigin": {
    "Contacts": {
      "Last_Name": "RingCentral - ${{{$.from}}}",
      "Mobile": "${{{$.from}}}",
      "Phone": "${{{$.from}}}"
    }
  },
  "whatcetraforzohobigin": {
    "Contacts": {
      "Last_Name": "${{{$.customerNumber}}}",
      "Mobile": "${{{$.customerNumber}}}",
      "Phone": "${{{$.customerNumber}}}"
    }
  },
  "twilioforzohorecruit": {
    "Contacts": {
      "Last_Name": "Twilio - ${{{$.from}}}",
      "Mobile": "${{{$.from}}}",
      "Phone": "${{{$.from}}}"
    },
    "Candidates": {
      "Last_Name": "Twilio - ${{{$.from}}}",
      "First_Name": "Twilio",
      "Mobile": "${{{$.from}}}",
      "Phone": "${{{$.from}}}"
    }
  },
  "messagebirdforzohorecruit": {
    "Contacts": {
      "Last_Name": "${{{$.contact.displayName}}} ${{{$.message.platform}}} - MessageBird",
      "Mobile": "${{{$.contact.msisdn}}}",
      "Phone": "${{{$.contact.msisdn}}}",
      "Email": "${{{$.contact.email}}}"
    },
    "Candidates": {
      "Last_Name": "${{{$.contact.displayName}}} ${{{$.message.platform}}} - MessageBird",
      "First_Name": "MessageBird",
      "Mobile": "${{{$.contact.msisdn}}}",
      "Phone": "${{{$.contact.msisdn}}}",
      "Email": "${{{$.contact.email}}}"
    }
  },
  "routemobileforzohorecruit": {
    "Contacts": {
      "Last_Name": "${{{$.contacts[0].profile.name}}} - Route Mobile",
      "Mobile": "${{{$.contacts[0].wa_id}}}",
      "Phone": "${{{$.contacts[0].wa_id}}}"
    },
    "Candidates": {
      "Last_Name": "${{{$.contacts[0].profile.name}}} - Route Mobile",
      "First_Name": "RouteMobile",
      "Mobile": "${{{$.contacts[0].wa_id}}}",
      "Phone": "${{{$.contacts[0].wa_id}}}"
    }
  },
  "routemobilewaforzohorecruit": {
    "Contacts": {
      "Last_Name": "${{{$.contacts[0].profile.name}}} - Route Mobile",
      "Mobile": "${{{$.contacts[0].wa_id}}}",
      "Phone": "${{{$.contacts[0].wa_id}}}"
    },
    "Candidates": {
      "Last_Name": "${{{$.contacts[0].profile.name}}} - Route Mobile",
      "First_Name": "RouteMobile",
      "Mobile": "${{{$.contacts[0].wa_id}}}",
      "Phone": "${{{$.contacts[0].wa_id}}}"
    }
  },
  "ringcentralforzohorecruit": {
    "Contacts": {
      "Last_Name": "RingCentral - ${{{$.from}}}",
      "Mobile": "${{{$.from}}}",
      "Phone": "${{{$.from}}}"
    },
    "Candidates": {
      "Last_Name": "RingCentral",
      "First_Name": "RingCentral",
      "Mobile": "${{{$.from}}}",
      "Phone": "${{{$.from}}}"
    }
  },
  "whatcetraforzohorecruit": {
    "Contacts": {
      "Last_Name": "${{{$.customerNumber}}}",
      "Mobile": "${{{$.customerNumber}}}",
      "Phone": "${{{$.customerNumber}}}"
    },
    "Candidates": {
      "Last_Name": "${{{$.customerNumber}}}",
      "First_Name": "WhatCetra",
      "Mobile": "${{{$.customerNumber}}}",
      "Phone": "${{{$.customerNumber}}}"
    }
  },
  "calendlyforzohorecruit": {
    "Contacts": {
      "Last_Name": "${{{$.contact.name}}}",
      "Mobile": "${{{$.contact.phone}}}",
      "Phone": "${{{$.contact.phone}}}",
      "Email": "${{{$.contact.email}}}"
    },
    "Candidates": {
      "Last_Name": "${{{$.contact.name}}}",
      "First_Name": "Calendly",
      "Mobile": "${{{$.contact.phone}}}",
      "Phone": "${{{$.contact.phone}}}",
      "Email": "${{{$.contact.email}}}"
    }
  },
  "calendlyforzohobigin": {
    "Contacts": {
      "Last_Name": "${{{$.contact.name}}}",
      "Mobile": "${{{$.contact.phone}}}",
      "Phone": "${{{$.contact.phone}}}",
      "Email": "${{{$.contact.email}}}"
    }
  },
  "twilioforleadsquared": {
    "Leads": {
      "LastName": "Twilio - ${{{$.from}}}",
      "Phone": "${{{$.from}}}"
    }
  },
  "whatcetraforleadsquared": {
    "Leads": {
      "LastName": "${{{$.customerNumber}}}",
      "Phone": "${{{$.customerNumber}}}"
    }
  },
  "messagebirdforleadsquared": {
    "Leads": {
      "LastName": "${{{$.contact.displayName}}} ${{{$.message.platform}}} - MessageBird",
      "Phone": "${{{$.contact.msisdn}}}",
      "EmailAddress": "${{{$.contact.email}}}"
    }
  },
  "routemobileforleadsquared": {
    "Leads": {
      "LastName": "${{{$.contacts[0].profile.name}}} - Route Mobile",
      "Phone": "${{{$.contacts[0].wa_id}}}",
      "EmailAddress": "${{{$.contact.email}}}"
    }
  },
  "routemobilewaforleadsquared": {
    "Leads": {
      "LastName": "${{{$.contacts[0].profile.name}}} - Route Mobile",
      "Phone": "${{{$.contacts[0].wa_id}}}",
      "EmailAddress": "${{{$.contact.email}}}"
    }
  },
  "ringcentralforleadsquared": {
    "Leads": {
      "LastName": "RingCentral - ${{{$.from}}}",
      "Phone": "${{{$.from}}}"
    }
  },
  "telnyxforzohodesk": {
    "tickets": {
      "subject": "${{{$.body}}}",
      "phone": "${{{$.customerNumber}}}",
      "channel": "Telnyx"
    },
    "contacts": {
      "lastName": "${{{$.customerNumber}}}",
      "phone": "${{{$.customerNumber}}}",
      "email": "${{{$.customerNumber}}}@telnyxforzohodesk.apps.ulgebra.com"
    }
  },
  "calendlyforleadsquared": {
    "Leads": {
      "LastName": "${{{$.contact.name}}} (Calendly)",
      "phone": "${{{$.contact.phone}}}",
      "EmailAddress": "${{{$.contact.email}}}"
    }
  },
  "ringcentralforzohodesk": {
    "tickets": {
      "subject": "${{{$.body}}}",
      "phone": "${{{$.customerNumber}}}",
      "channel": "Rincentral"
    },
    "contacts": {
      "lastName": "${{{$.customerNumber}}}",
      "phone": "${{{$.customerNumber}}}",
      "email": "${{{$.customerNumber}}}@ringcentralforzohodesk.apps.ulgebra.com"
    }
  },
  "whatsappforzohodesk": {
    "tickets": {
      "subject": "${{{$.message}}}",
      "phone": "${{{$.from}}}",
      "channel": "Whatsapp"
    },
    "contacts": {
      "lastName": "${{{$.contact.name}}}",
      "phone": "${{{$.from}}}",
      "email": "${{{$.from}}}@whatsappforzohodesk.apps.ulgebra.com"
    }
  },
  "pinnacleforzohodesk": {
    "tickets": {
      "subject": "${{{$.message}}}",
      "phone": "${{{$.from}}}",
      "channel": "Pinnacle"
    },
    "contacts": {
      "lastName": "${{{$.contact.name}}}",
      "phone": "${{{$.from}}}",
      "email": "${{{$.from}}}@pinnacleforzohodesk.apps.ulgebra.com"
    }
  },
  "whatsappforzohobigin": {
    "Contacts": {
      "Last_Name": "Whatsapp - ${{{$.from}}}",
      "Mobile": "${{{$.from}}}",
      "Phone": "${{{$.from}}}"
    }
  },
  "pinnacleforzohobigin": {
    "Contacts": {
      "Last_Name": "Pinnacle - ${{{$.from}}}",
      "Mobile": "${{{$.from}}}",
      "Phone": "${{{$.from}}}"
    }
  },
  "acuityschedulingfordynamicscrm": {
    "lead": {
      "firstname": "Acuity - ",
      "lastname": "${{{$.contact.name}}}",
      "emailaddress1": "${{{$.contact.email}}}",
      "telephone1": "${{{$.contact.phone}}}"
    },
    "account": {
      "name": "Acuity - ${{{$.contact.name}}}",
      "telephone1": "${{{$.contact.phone}}}"
    },
    "contact": {
      "firstname": "Acuity - ",
      "lastname": "${{{$.contact.name}}}",
      "emailaddress1": "${{{$.contact.email}}}",
      "telephone1": "${{{$.contact.phone}}}"
    }
  },
  "calendlyfordynamicscrm": {
    "lead": {
      "firstname": "Calendly - ",
      "lastname": "${{{$.contact.name}}}",
      "emailaddress1": "${{{$.contact.email}}}",
      "telephone1": "${{{$.contact.phone}}}"
    },
    "account": {
      "name": "Calendly - ${{{$.contact.name}}}",
      "telephone1": "${{{$.contact.phone}}}"
    },
    "contact": {
      "firstname": "Calendly - ",
      "lastname": "${{{$.contact.name}}}",
      "emailaddress1": "${{{$.contact.email}}}",
      "telephone1": "${{{$.contact.phone}}}"
    }
  },
  "twiliofordynamicscrm": {
    "lead": {
      "firstname": "Twilio - ",
      "lastname": "${{{$.from}}}",
      "telephone1": "${{{$.from}}}"
    },
    "account": {
      "name": "Twilio - ${{{$.from}}}",
      "telephone1": "${{{$.from}}}"
    },
    "contact": {
      "firstname": "Twilio - ",
      "lastname": "${{{$.from}}}",
      "telephone1": "${{{$.from}}}"
    }
  },
  "messagebirdfordynamicscrm": {
    "lead": {
      "firstname": "${{{$.contact.displayName}}} ${{{$.message.platform}}} - MessageBird",
      "lastname": "${{{$.contact.msisdn}}}",
      "emailaddress1": "${{{$.contact.email}}}",
      "telephone1": "${{{$.contact.msisdn}}}"
    },
    "account": {
      "name": "${{{$.contact.displayName}}} ${{{$.message.platform}}} - MessageBird",
      "telephone1": "${{{$.contact.msisdn}}}"
    },
    "contact": {
      "firstname": "${{{$.contact.displayName}}} ${{{$.message.platform}}} - MessageBird",
      "lastname": "${{{$.contact.msisdn}}}",
      "emailaddress1": "${{{$.contact.email}}}",
      "telephone1": "${{{$.contact.msisdn}}}"
    }
  },
  "routemobilefordynamicscrm": {
    "lead": {
      "firstname": "${{{$.contacts[0].profile.name}}} - Route Mobile",
      "lastname": "${{{$.contacts[0].wa_id}}}",
      "telephone1": "${{{$.contacts[0].wa_id}}}"
    },
    "account": {
      "name": "${{{$.contacts[0].profile.name}}} - Route Mobile",
      "telephone1": "${{{$.contacts[0].wa_id}}}"
    },
    "contact": {
      "firstname": "${{{$.contacts[0].profile.name}}} - Route Mobile",
      "lastname": "${{{$.contacts[0].wa_id}}}",
      "telephone1": "${{{$.contacts[0].wa_id}}}"
    }
  },
  "routemobilewafordynamicscrm": {
    "lead": {
      "firstname": "${{{$.contacts[0].profile.name}}} - Route Mobile",
      "lastname": "${{{$.contacts[0].wa_id}}}",
      "telephone1": "${{{$.contacts[0].wa_id}}}"
    },
    "account": {
      "name": "${{{$.contacts[0].profile.name}}} - Route Mobile",
      "telephone1": "${{{$.contacts[0].wa_id}}}"
    },
    "contact": {
      "firstname": "${{{$.contacts[0].profile.name}}} - Route Mobile",
      "lastname": "${{{$.contacts[0].wa_id}}}",
      "telephone1": "${{{$.contacts[0].wa_id}}}"
    }
  },
  "whatcetrafordynamicscrm": {
    "lead": {
      "firstname": "Whatcetra - ",
      "lastname": "${{{$.customerNumber}}}",
      "telephone1": "${{{$.customerNumber}}}"
    },
    "account": {
      "name": "Whatcetra - ${{{$.customerNumber}}}",
      "telephone1": "${{{$.customerNumber}}}"
    },
    "contact": {
      "firstname": "Whatcetra - ",
      "lastname": "${{{$.customerNumber}}}",
      "telephone1": "${{{$.customerNumber}}}"
    }
  },
  "ringcentralfordynamicscrm": {
    "lead": {
      "firstname": "RingCentral - ",
      "lastname": "${{{$.from}}}",
      "telephone1": "${{{$.from}}}"
    },
    "account": {
      "name": "RingCentral - ${{{$.from}}}",
      "telephone1": "${{{$.from}}}"
    },
    "contact": {
      "firstname": "RingCentral - ",
      "lastname": "${{{$.from}}}",
      "telephone1": "${{{$.from}}}"
    }
  },
  "twilioforactivecampaign": {
    "Contacts": {
      "firstName": "Twilio - ${{{$.from}}}",
      "phone": "${{{$.from}}}",
      "email": "${{{$.from}}}@twilioforactivecampaign.apps.ulgebra.com"
    }
  },
  "twilioforslack": {
    "Channels": {
      "name": "Twilio - ${{{$.from}}}"
    }
  },
  "messagebirdforslack": {
    "Channels": {
      "name": "Messagebird - ${{{$.contact.msisdn}}}"
    }
  },
  "routemobileforslack": {
    "Channels": {
      "name": "RouteMobile - ${{{$.contacts[0].profile.name}}}"
    }
  },
  "routemobilewaforslack": {
    "Channels": {
      "name": "RouteMobile - ${{{$.contacts[0].profile.name}}}"
    }
  },
  "calendlyforairtable": {
    "default": {
      "Email": "${{{$.contact.email}}}",
      "Name": "${{{$.contact.name}}}",
      "Phone": "${{{$.contact.phone}}}"
    }
  },
  "acuityschedulingforairtable": {
    "default": {
      "Email": "${{{$.contact.email}}}",
      "Name": "${{{$.contact.name}}}",
      "Phone": "${{{$.contact.phone}}}"
    }
  },
  "twilioforairtable": {
    "default": {
      "Name": "${{{$.from}}}",
      "Phone": "${{{$.from}}}",
      "Title": "Twilio - ${{{$.from}}} to ${{{$.to}}}"
    }
  },
  "intercomforzohocrm": {
    "Leads": {
      "todolist__Intercom_ID": "${{{$.intercomId}}}",
      "Last_Name": "${{{$.name}}}  - Intercom",
      "Email": "${{{$.email}}}",
      "Phone": "${{{$.phone}}}",
      "Lead_Source": "Intercom"
    },
    "Contacts": {
      "todolist__Intercom_ID": "${{{$.intercomId}}}",
      "Last_Name": "${{{$.name}}} - Intercom",
      "Email": "${{{$.email}}}",
      "Phone": "${{{$.phone}}}"
    },
    "Accounts": {
      "todolist__Intercom_ID": "${{{$.intercomId}}}",
      "Account_Name": "${{{$.name}}} - Intercom",
      "Email": "${{{$.email}}}",
      "Phone": "${{{$.phone}}}"
    }
  },
  "calendlyforfreshworkscrm": {
    "lead": {
      "last_name": "${{{$.contact.name}}}",
      "email": "${{{$.contact.email}}}",
      "mobile_number": "${{{$.contact.phone}}}"
    },
    "contact": {
      "last_name": "${{{$.contact.name}}}",
      "email": "${{{$.contact.email}}}",
      "mobile_number": "${{{$.contact.phone}}}"
    },
    "sales_account": {
      "name": "${{{$.contact.name}}}",
      "phone": "${{{$.contact.phone}}}"
    }
  },
  "whatcetraforfreshworkscrm": {
    "lead": {
      "last_name": "${{{$.customerNumber}}}",
      "mobile_number": "${{{$.customerNumber}}}",
      "email": "${{{$.customerNumber}}}@whatcetraforfreshworkscrm.apps.ulgebra.com"
    },
    "contact": {
      "last_name": "${{{$.customerNumber}}}",
      "mobile_number": "${{{$.customerNumber}}}",
      "email": "${{{$.customerNumber}}}@whatcetraforfreshworkscrm.apps.ulgebra.com"
    },
    "sales_account": {
      "name": "${{{$.customerNumber}}}",
      "phone": "${{{$.customerNumber}}}"
    }
  },
  "twilioforfreshworkscrm": {
    "lead": {
      "last_name": "${{{$.from}}}",
      "mobile_number": "${{{$.from}}}",
      "email": "${{{$.from}}}@twilioforfreshworkscrm.apps.ulgebra.com"
    },
    "contact": {
      "last_name": "${{{$.from}}}",
      "mobile_number": "${{{$.from}}}",
      "email": "${{{$.from}}}@twilioforfreshworkscrm.apps.ulgebra.com"
    },
    "sales_account": {
      "name": "${{{$.from}}}",
      "phone": "${{{$.from}}}"
    }
  },
  "fast2smsforfreshworkscrm": {
    "lead": {
      "last_name": "${{{$.from}}}",
      "mobile_number": "${{{$.from}}}",
      "email": "${{{$.from}}}@fast2smsforfreshworkscrm.apps.ulgebra.com"
    },
    "contact": {
      "last_name": "${{{$.from}}}",
      "mobile_number": "${{{$.from}}}",
      "email": "${{{$.from}}}@fast2smsforfreshworkscrm.apps.ulgebra.com"
    },
    "sales_account": {
      "name": "${{{$.from}}}",
      "phone": "${{{$.from}}}"
    }
  },
  "pinnacleforfreshworkscrm": {
    "lead": {
      "last_name": "${{{$.contact.name}}}",
      "mobile_number": "${{{$.from}}}",
      "email": "${{{$.from}}}@pinnacleforfreshworkscrm.apps.ulgebra.com"
    },
    "contact": {
      "last_name": "${{{$.contact.name}}}",
      "mobile_number": "${{{$.from}}}",
      "email": "${{{$.from}}}@pinnacleforfreshworkscrm.apps.ulgebra.com"
    },
    "sales_account": {
      "name": "${{{$.contact.name}}}",
      "phone": "${{{$.from}}}"
    }
  },
  "messagebirdforfreshworkscrm": {
    "lead": {
      "first_name": "MessageBird - ",
      "last_name": "${{{$.contact.displayName}}} - ${{{$.message.platform}}}",
      "mobile_number": "${{{$.contact.msisdn}}}",
      "email": "${{{$.contact.msisdn}}}@messagebirdforfreshworkscrm.apps.ulgebra.com"
    },
    "contact": {
      "first_name": "MessageBird -",
      "last_name": "${{{$.contact.displayName}}} - ${{{$.message.platform}}}",
      "mobile_number": "${{{$.contact.msisdn}}}",
      "email": "${{{$.contact.msisdn}}}@messagebirdforfreshworkscrm.apps.ulgebra.com"
    },
    "sales_account": {
      "name": "MessageBird - ${{{$.contact.displayName}}} - ${{{$.message.platform}}}",
      "phone": "${{{$.contact.msisdn}}}"
    }
  },
  "routemobileforfreshworkscrm": {
    "lead": {
      "first_name": "Route Mobile - ",
      "last_name": "${{{$.contacts[0].profile.name}}}",
      "mobile_number": "${{{$.contacts[0].wa_id}}}",
      "email": "${{{$.contacts[0].wa_id}}}@routemobileforfreshworkscrm.apps.ulgebra.com"
    },
    "contact": {
      "first_name": "Route Mobile -",
      "last_name": "${{{$.contacts[0].profile.name}}}",
      "mobile_number": "${{{$.contacts[0].wa_id}}}",
      "email": "${{{$.contacts[0].wa_id}}}@routemobileforfreshworkscrm.apps.ulgebra.com"
    },
    "sales_account": {
      "name": "Route Mobile - ${{{$.contacts[0].profile.name}}}",
      "phone": "${{{$.contacts[0].wa_id}}}"
    }
  },
  "routemobilewaforfreshworkscrm": {
    "lead": {
      "first_name": "Route Mobile - ",
      "last_name": "${{{$.contacts[0].profile.name}}}",
      "mobile_number": "${{{$.contacts[0].wa_id}}}",
      "email": "${{{$.contacts[0].wa_id}}}@routemobilewaforfreshworkscrm.apps.ulgebra.com"
    },
    "contact": {
      "first_name": "Route Mobile -",
      "last_name": "${{{$.contacts[0].profile.name}}}",
      "mobile_number": "${{{$.contacts[0].wa_id}}}",
      "email": "${{{$.contacts[0].wa_id}}}@routemobilewaforfreshworkscrm.apps.ulgebra.com"
    },
    "sales_account": {
      "name": "Route Mobile - ${{{$.contacts[0].profile.name}}}",
      "phone": "${{{$.contacts[0].wa_id}}}"
    }
  },
  "ringcentralforfreshworkscrm": {
    "lead": {
      "first_name": "RingCentral -",
      "last_name": "${{{$.from}}}",
      "mobile_number": "${{{$.from}}}",
      "email": "${{{$.from}}}@ringcentralforfreshworkscrm.apps.ulgebra.com"
    },
    "contact": {
      "first_name": "RingCentral -",
      "last_name": "${{{$.from}}}",
      "mobile_number": "${{{$.from}}}",
      "email": "${{{$.from}}}@ringcentralforfreshworkscrm.apps.ulgebra.com"
    },
    "sales_account": {
      "name": "RingCentral - ${{{$.from}}}",
      "phone": "${{{$.from}}}"
    }
  },
  "acuityschedulingforfreshworkscrm": {
    "lead": {
      "last_name": "${{{$.contact.name}}}",
      "email": "${{{$.contact.email}}}",
      "mobile_number": "${{{$.contact.phone}}}"
    },
    "contact": {
      "last_name": "${{{$.contact.name}}}",
      "email": "${{{$.contact.email}}}",
      "mobile_number": "${{{$.contact.phone}}}"
    },
    "sales_account": {
      "name": "${{{$.contact.name}}}",
      "phone": "${{{$.contact.phone}}}"
    }
  },
  "twilioforzendesksupport": {
    "tickets": {
      "name": "${{{$.from}}}",
      "phone": "${{{$.from}}}",
      "email": "${{{$.from}}}@twilioforzendesksupport.apps.ulgebra.com"
    }
  },
  "fast2smsforzendesksupport": {
    "tickets": {
      "name": "${{{$.from}}}",
      "phone": "${{{$.from}}}",
      "email": "${{{$.from}}}@fast2smsforzendesksupport.apps.ulgebra.com"
    }
  },
  "whatsappforzendesksupport": {
    "tickets": {
      "name": "WhatsApp - ${{{$.contact.name}}}",
      "phone": "${{{$.from}}}",
      "email": "${{{$.from}}}@whatsappforzendesksupport.apps.ulgebra.com"
    }
  },
  "pinnacleforzendesksupport": {
    "tickets": {
      "name": "Pinnacle - ${{{$.contact.name}}}",
      "phone": "${{{$.from}}}",
      "email": "${{{$.from}}}@pinnacleforzendesksupport.apps.ulgebra.com"
    }
  },
  "messagebirdforzendesksupport": {
    "tickets": {
      "name": "${{{$.contact.displayName}}} ${{{$.message.from}}} via ${{{$.message.platform}}}",
      "phone": "${{{$.contact.msisdn}}}",
      "email": "${{{$.contact.email}}}"
    }
  },
  "routemobileforzendesksupport": {
    "tickets": {
      "name": "${{{$.contacts[0].profile.name}}}",
      "phone": "${{{$.contacts[0].wa_id}}}"
    }
  },
  "routemobilewaforzendesksupport": {
    "tickets": {
      "name": "${{{$.contacts[0].profile.name}}}",
      "phone": "${{{$.contacts[0].wa_id}}}"
    }
  },
  "whatcetraforzendesksupport": {
    "tickets": {
      "name": "${{{$.customerNumber}}}",
      "phone": "${{{$.customerNumber}}}"
    }
  },
  "fast2smsforzohodesk": {
    "tickets": {
      "subject": "${{{$.from}}}",
      "phone": "${{{$.from}}}",
      "channel": "Fast2SMS"
    },
    "contacts": {
      "lastName": "${{{$.from}}}",
      "phone": "${{{$.from}}}",
      "email": "${{{$.from}}}@fast2smsforzohodesk.apps.ulgebra.com"
    }
  },
  "whatcetraforzohodesk": {
    "tickets": {
      "subject": "${{{$.body}}}",
      "phone": "${{{$.customerNumber}}}",
      "channel": "Whatcetra"
    }
  }
};
